module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"title":{"server":"Сети","plan":"Тарифный план","stats":"Статистика"},"prolong":{"confirm":"Сменить","order":"Отмена"},"nav":{"notify":"Уведомления","config":"Настройки"},"newServer":"Новая сеть","activeUnder":"Действует до {date}","actions":{"prolong":"Продлить","changePlan":"Сменить тариф"}}}')
  delete Component.options._Ctor
}
